import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowChevronDownBold = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 8,
	viewBox: "0 0 13 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M6.5 5.09128L11.5558 0L13 1.45436L6.5 8L0 1.45436L1.44422 0L6.5 5.09128Z",
		fill: "black"
	})]
});
const ForwardRef = forwardRef(SvgArrowChevronDownBold);
export { ForwardRef as ReactComponent };
